// extracted by mini-css-extract-plugin
module.exports = {"price":"f9","currency":"f-","strikethrough":"f_","secondary":"ha"};